import { useEffect } from "react";
import { showAppBadge } from "../lib/appBadge";

/** Browser notifications round two (2026-10-18): the installed app's icon badge, while a tab is open (signing out clears it, `push.ts`). Rail
 *  dots (the founder, 2026-10-18): it shows the unread tickets in the person's queue, the number behind the Inbox dot (an icon badge is a number
 *  by nature), and 0 clears it. The shell keeps the count live in every browser; this hook only hands it to the Badging API where it exists.
 *  The browser itself shows a badge only for an installed app. */
export const badgeSupported = () => typeof navigator !== "undefined" && "setAppBadge" in navigator;

export function useAppBadge(unreadQueue: number | undefined): void {
  const on = badgeSupported();
  useEffect(() => { if (on) void showAppBadge(unreadQueue); }, [on, unreadQueue]);
}
